<!-- eslint-disable max-len -->
<template>
  <div>
    <DefaultLayout :loading="loading">
      <ResendConfirmationOptions
        style="margin-top: 20px"
        v-if="showResendOptions"
      />
      <template #header>
        <template v-if="render === 'view'">
          <div
            :style="{
              display: 'flex',
              flexDirection: 'column',
              gap: '0.75rem',
            }"
          >
            <h2 class="main-title">Confirme seu celular</h2>
            <p
              :style="{
                fontSize: '1rem',
                lineHeight: '1.5rem',
                fontWeight: 400,
              }"
            >
              {{
                showResendOptions
                  ? "Escolha por qual meio você quer receber o código de verificação."
                  : "Para prosseguir, insira o código enviado para o celular"
              }}
              <span v-if="!showResendOptions" :style="{ fontWeight: 600 }">{{
                phone | phoneMask({ lastDigits: true })
              }}</span>
            </p>
          </div>
        </template>

        <template v-else>
          <p class="lead" v-if="hasToSendCode">
            Para prosseguir, insira o código de verificação enviado para o
            celular abaixo:
          </p>

          <p class="lead" v-else>
            Para prosseguir, acesse o link enviado para o número:
          </p>
        </template>
      </template>
      <div
        :style="{
          display: 'flex',
          flexDirection: 'column',
          gap: '1.5rem',
          alignItems: 'center',
          'margin-top': '24px',
        }"
        v-if="!showResendOptions"
      >
        <VerificationCode
          v-if="hasToSendCode"
          ref="verification-code"
          :length="6"
          @onComplete="completedVerificationCode"
        />

        <div
          v-if="checkingConfirmationCode && !successConfirmation"
          class="loading-message"
        >
          <InlineSpinner
            :border="3"
            :width="20"
            :height="20"
            primaryColor="#94A3B8"
            secondaryColor="#E2E8F0"
          />
          <p>Verificando código...</p>
        </div>

        <div
          v-if="!checkingConfirmationCode && confirmationCodeChecked"
          class="loading-message"
        >
          <div class="success" v-if="successConfirmation">
            <AssetV3 dir="icons" name="check-circle-success-small.svg" />
            <p>Código validado</p>
          </div>
          <div class="danger" v-else>
            <p>Código inválido</p>
          </div>
        </div>

        <div
          class="text-center link"
          v-if="!checkingConfirmationCode && !successConfirmation"
        >
          <a
            @click="resendConfirmationCode"
            :class="{ disabled: chosenConfirmationResendType }"
          >
            {{ resendText }}
            {{ resendCounter !== 0 ? `(${resendCounter}s)` : "" }}
          </a>
        </div>
      </div>
    </DefaultLayout>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';
import AssetV3 from '@/components/common/AssetV3.vue';
import VerificationCode from '@/feature/minified-onboarding/components/VerificationCode.vue';
import InlineSpinner from '@/components/common/InlineSpinner.vue';
import StringMixing from '@/mixins/string';
import UtilMixin from '@/mixins/util';
import ResendConfirmationOptions from '@/feature/minified-onboarding/components/ResendConfirmationOptions.vue';
import DefaultLayout from '@/feature/minified-onboarding/layout/DefaultLayout.vue';

export default {
  name: 'onboarding-minified-confirmation',
  mixins: [StringMixing, UtilMixin],
  props: {
    render: {
      type: String,
      default: 'view',
    },
    device: {
      type: String,
      default: 'mobile',
    },
  },
  computed: {
    ...mapGetters('minifiedOnboarding', [
      'onboarding',
      'phone',
      'onboardingToken',
      'hasTrustedOnboarding',
      'chosenConfirmationResendType',
      'disableTheResendCounter',
      'showResendOptions',
      'confirmationResendType',
      'nextRoute',
    ]),
    hasToSendCode() {
      return this.device === 'mobile' || this.hasTrustedOnboarding;
    },
  },
  data: () => ({
    resendCounter: 0,
    checkingConfirmationCode: false,
    confirmationCodeChecked: false,
    successConfirmation: null,
    securityCode: null,
    resendText: null,
    loading: true,
  }),
  methods: {
    ...mapActions('minifiedOnboarding', [
      'resendConfirmation',
      'sendConfirmationCode',
      'updateStep',
      'setShowResendOptions',
      'getOnboarding',
    ]),
    ...mapActions('auth', ['setToken']),
    ...mapMutations('minifiedOnboarding', [
      'setChosenConfirmationResendType',
      'setDisableTheResendCounter',
    ]),
    controllerResendCounter() {
      if (this.resendCounter !== 0) return;

      if (this.disableTheResendCounter) {
        this.resendCounter = 20;
        this.startResendCounter();
        this.setDisableTheResendCounter();
      }
    },
    resendConfirmationCode() {
      if (!this.chosenConfirmationResendType) {
        this.resendCounter = 20;
        this.setShowResendOptions({ showResendOptions: true });
        this.startResendCounter();
      }
    },
    startResendCounter() {
      const resendInterval = setInterval(() => {
        this.resendCounter -= 1;
        if (this.resendCounter === 0) {
          clearInterval(resendInterval);
          this.setChosenConfirmationResendType();
        }
      }, 1000);
    },
    async completedVerificationCode(securityCode) {
      this.checkingConfirmationCode = true;

      const { success } = await this.sendConfirmationCode({
        securityCode,
      });

      this.checkingConfirmationCode = false;

      this.confirmationCodeChecked = true;
      this.successConfirmation = success;

      // const { userId, onboardingToken } = this.$route.query;

      console.log('success', success);
      console.log('nextRoute', this.nextRoute);

      if (this.successConfirmation) {
        console.log('entrei no success');
        await this.$router.go(0);
      } else {
        this.$refs['verification-code'].clearInput();
      }
    },
  },
  async created() {
    const { userId, onboardingToken, onboardingId } = this.$route.query;
    this.loading = true;
    await this.setToken({ token: onboardingToken });
    await this.getOnboarding({ userId, onboardingId });
    this.loading = false;
  },
  mounted() {
    this.resendText = this.hasToSendCode
      ? 'Não recebi o código'
      : 'Não recebi o link';

    this.controllerResendCounter();

    const { forceResendToken } = this.$route.query;
    if (forceResendToken) this.resendConfirmationCode();
  },
  components: {
    VerificationCode,
    InlineSpinner,
    AssetV3,
    ResendConfirmationOptions,
    DefaultLayout,
  },
};
</script>

  <style lang="scss" scoped>
.wrapper {
  min-height: unset !important;
}

.verification-code {
  margin-top: 24px;
  margin-bottom: 16px;
}

.loading-message {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  margin-bottom: 36px;

  p {
    color: var(--gray-500);
  }

  .success {
    display: flex;
    gap: 6px;

    justify-content: center;
    align-items: center;

    p {
      color: var(--green-500);
    }

    img {
      width: 16px;
      height: 16px;
    }
  }

  .danger {
    p {
      color: var(--red-300);
    }
  }
}

.extra-info {
  margin-top: 36px;

  font-size: 14px;
  line-height: 24px;
  font-weight: 400;

  color: var(--gray-500);
}

.link {
  -webkit-tap-highlight-color: transparent;
  a {
    color: #ED0059;
  }

  .disabled {
    color: var(--gray-400);
    pointer-events: none;
  }
}
</style>
